import { render, staticRenderFns } from "./jsonMapperComponent.vue?vue&type=template&id=5196ec24&scoped=true"
import script from "./jsonMapperComponent.vue?vue&type=script&lang=js"
export * from "./jsonMapperComponent.vue?vue&type=script&lang=js"
import style0 from "./jsonMapperComponent.vue?vue&type=style&index=0&id=5196ec24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5196ec24",
  null
  
)

export default component.exports